module.exports = __webpack_public_path__ + "static/media/bartender.fdb58324.png";